// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.supportMainTopSection {
    background-color: #25335b;
    padding: 25px 15px !important;
    color: #fff !important;
}
.supportsecondSection {
    border: 1px solid gainsboro;
    padding: 20px;
    margin-bottom: 10px;
}
.text-center {
    text-align: center!important;
}
.btn-primary {
    color: #fff;
    background-color: #25335b;
    border-color: #25335b;
}

.btn {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.btn:hover {
    color: var(--bs-btn-hover-color);
    background-color: #3ca8e8;
    border-color: #3ca8e8;
}
.card {
    margin-bottom: 15px;
    border-radius: 0;
    box-shadow: 0 3px 5px rgba(0, 0, 0, .1);
}
.form-group {
    margin-bottom: 1rem;
}
.col-form-label {
    padding-top: calc(0.375rem + 1px);
    padding-bottom: calc(0.375rem + 1px);
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5;
}
.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.text-md-right {
    text-align: right!important;
}`, "",{"version":3,"sources":["webpack://./src/SidebarComponent/Support.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IAGzB,iBAAiB;IACjB,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,8HAA8H;AAClI;AACA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;AAC3C;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IACtB,qEAAqE;AACzE;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".supportMainTopSection {\r\n    background-color: #25335b;\r\n    padding: 25px 15px !important;\r\n    color: #fff !important;\r\n}\r\n.supportsecondSection {\r\n    border: 1px solid gainsboro;\r\n    padding: 20px;\r\n    margin-bottom: 10px;\r\n}\r\n.text-center {\r\n    text-align: center!important;\r\n}\r\n.btn-primary {\r\n    color: #fff;\r\n    background-color: #25335b;\r\n    border-color: #25335b;\r\n}\r\n\r\n.btn {\r\n    display: inline-block;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    border: 1px solid transparent;\r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 1rem;\r\n    line-height: 1.5;\r\n    border-radius: 0.25rem;\r\n    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\r\n}\r\n.btn:hover {\r\n    color: var(--bs-btn-hover-color);\r\n    background-color: #3ca8e8;\r\n    border-color: #3ca8e8;\r\n}\r\n.card {\r\n    margin-bottom: 15px;\r\n    border-radius: 0;\r\n    box-shadow: 0 3px 5px rgba(0, 0, 0, .1);\r\n}\r\n.form-group {\r\n    margin-bottom: 1rem;\r\n}\r\n.col-form-label {\r\n    padding-top: calc(0.375rem + 1px);\r\n    padding-bottom: calc(0.375rem + 1px);\r\n    margin-bottom: 0;\r\n    font-size: inherit;\r\n    line-height: 1.5;\r\n}\r\n.form-control {\r\n    display: block;\r\n    width: 100%;\r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 1rem;\r\n    line-height: 1.5;\r\n    color: #495057;\r\n    background-color: #fff;\r\n    background-clip: padding-box;\r\n    border: 1px solid #ced4da;\r\n    border-radius: 0.25rem;\r\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\r\n}\r\n\r\n.text-md-right {\r\n    text-align: right!important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
